import {
  Anchor,
  Box,
  Flex,
  HoverCard,
  List,
  Modal,
  Title,
} from '@mantine/core';
import PlotImportForm from './PlotsImportForm';
import { Trans, useTranslation } from 'react-i18next';
import useValidatedSearchParams from '../../router/useValidatedSearchParams';
import { BetaIcon } from '../../../lib/components';

const PLOT_UPLOAD_DOCS_URL =
  'https://docs.live-eo.com/tradeaware/using-the-tradeaware-web-app/plot-upload-and-analysis-trouble-shooting';

const InfoIcon = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'plots.import.validations',
  });

  return (
    <HoverCard>
      <HoverCard.Target>
        <Box>
          <BetaIcon size="sm" icon="circle-info" />
        </Box>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Box p="md">
          <List mb="md">
            <List.Item>{t('fileSize', { size: 10 })}</List.Item>
            <List.Item>{t('plotSize', { size: 10000 })}</List.Item>
            <List.Item>{t('plotSelfIntersect')}</List.Item>
            <List.Item>{t('file2DGeometries')}</List.Item>
            <List.Item>{t('customPlotNaming')}</List.Item>
          </List>

          <Trans
            i18nKey="plots.import.validations.info"
            components={{
              a: <Anchor href={PLOT_UPLOAD_DOCS_URL} target="_blank" />,
            }}
          />
        </Box>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};

const PlotsImportModal = () => {
  const { validatedParams, setValidatedParam } = useValidatedSearchParams();
  const { t } = useTranslation();

  const isOpen = validatedParams['import-modal'] === 'open';

  const handleClose = (): void => {
    setValidatedParam('import-modal', null);
  };

  return (
    <Modal
      centered
      keepMounted={false}
      opened={isOpen}
      onClose={handleClose}
      title={
        <Flex justify="space-between" align="center" w="98%">
          <Title order={3}>{t('plots.import.title')}</Title>
          <InfoIcon />
        </Flex>
      }
      styles={{
        title: { width: '100%' },
        body: { padding: 0 },
      }}
    >
      <PlotImportForm />
    </Modal>
  );
};

export default PlotsImportModal;
